import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AdminLayout } from "./components/AdminLayout";
import { Dashboard } from "./pages/Dashboard";
import { ProductRegister } from "./pages/ProductRegister";
import { CourseManagement } from "./pages/CourseManagement";
import { ProductDetail } from "./pages/ProductDetail";
import { StudentRecords } from "./pages/StudentRecords";
import { StudentRecordDetail } from "./pages/StudentRecordDetail";
import { Login } from "./pages/Login";
import authUtils from "./utils/auth";

// 인증이 필요한 컴포넌트를 감싸는 HOC
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return authUtils.isAuthenticated() ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" />
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-register"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ProductRegister />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/course-management"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CourseManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/:id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ProductDetail />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-records"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <StudentRecords />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-records/:id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <StudentRecordDetail />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
